import { Image } from '@tribeplatform/gql-client/types'
import { useMember } from '@tribeplatform/react-sdk/hooks'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'

type MemberAvatarProps = { id: string }

export const MemberAvatar = ({ id }: MemberAvatarProps) => {
  const { data: member, isInitialLoading } = useMember({
    variables: { id },
    fields: { profilePicture: 'all' },
  })

  if (isInitialLoading) {
    return (
      <div role="status" className="max-w-sm animate-pulse">
        <div className="rounded-full bg-skeleton h-10 w-10" />
      </div>
    )
  }
  if (!member && !isInitialLoading) {
    return null
  }

  const profilePicture =
    (member?.profilePicture as Image)?.urls?.thumb ||
    (member?.profilePicture as Image)?.url
  return <Avatar key={member.id} name={member.name} src={profilePicture} />
}
